export function downloadImg(currentImgInfo) {
  const { path, name } = currentImgInfo
  const aLink = document.createElement('a')
  aLink.download = name
  aLink.href = path
  aLink.dispatchEvent(new MouseEvent('click', {}))
}